import { axiosWithRetry } from '../../shared/lib/axios'
import { getAPIendpointPrefix } from '../actions/apiHelper'
import { getCookie } from '../middleware/macmillan'
import Parse from 'url-parse'
import _ from 'lodash'

import {
  SAVE_PROGRESS_REQUEST,
  SAVE_PROGRESS_SUCCESS,
  SAVE_PROGRESS_FAILURE,
  SHOW_NETWORK_ISSUE_MODAL
} from '../actions'

export const saveProgress = async (activity, dispatch, getState) => {
  // don't save progress in preview mode
  if (activity.config.isInstructorView === true || activity.config.simulateData !== undefined) {
    return Promise.reject('Preview mode: no progress saved')
  }

  if (!activity || !activity.studentData || !activity.studentData.user_id || !activity.studentData.assignment_id ||
    activity.studentData.user_rights !== '1_student') {
    return Promise.reject('cannot save activity progress--missing required data or not a student')
  }

  // TDouglas 05/08/2016 enabling this for macmillan users to get macmillan standalone progress saving working
  if ((activity.score.activityScore < activity.score.scoreTarget) &&
    activity.studentData.user_id_type !== 'macmillan') {
    return Promise.resolve()
  }

  const payload = {
    user_id: activity.studentData.user_id,
    user_id_type: activity.studentData.user_id_type,
    assignment_id: activity.studentData.assignment_id
  }

  let activityState = {}
  const isRetake = !(!activity.finalScore)

  // add retake
  if (!isRetake) {
    if (!activity.score.hintCount) {
      activity.score.hintCount = 0
    }

    if (!activity.score.completedQuestionCount) {
      activity.score.completedQuestionCount = 0
    }

    activityState = {
      target: activity.score.scoreTarget,
      score: activity.score.activityScore,
      qr: activity.studentData.activity_questions_received,
      tp: [],
      hintCount: activity.score.hintCount,
      completedQuestionCount: activity.score.completedQuestionCount,
      quizTimes: activity.studentData.quizTimes || [],
      questions: mapQuestionViewData(activity.questions)
    }

    const lastTimeObj = _.last(activityState.quizTimes)
    const hasCompletedQuiz = activityState.score >= activityState.target

    // If we're starting the quiz for the first time,
    // push the first time object in quizTimes
    if (!activityState.quizTimes.length) {
      activityState.quizTimes.push({ startQuizTime: Date.now() })
      activity.studentData.quizTimes = activityState.quizTimes
    } else if (hasCompletedQuiz && !lastTimeObj.completeQuizTime) {
      // if we are finishing the quiz, then add completeQuizTime
      lastTimeObj.completeQuizTime = Date.now()
      activityState.quizTimes.splice(-1, 1, lastTimeObj)
      activity.studentData.quizTimes = activityState.quizTimes
    } else if (!hasCompletedQuiz && lastTimeObj.startQuizTime && lastTimeObj.completeQuizTime) {
      // if we are returning to a quiz, push a new object onto it
      activityState.quizTimes.push({ startQuizTime: Date.now() })
      activity.studentData.quizTimes = activityState.quizTimes
    }
  } else {
    if (!activity.finalScore.hintCount) {
      activity.finalScore.hintCount = 0
    }
    if (!activity.finalScore.completedQuestionCount) {
      activity.finalScore.completedQuestionCount = 0
    }

    activityState = {
      target: activity.finalScore.scoreTarget,
      score: activity.finalScore.activityScore,
      qr: activity.finalScore.final_questions_received,
      tp: [],
      hintCount: activity.finalScore.hintCount,
      completedQuestionCount: activity.finalScore.completedQuestionCount,
      quizTimes: activity.studentData.quizTimes,
      questions: mapQuestionViewData(activity.questions)
    }

    activity.studentData.rt = _.get(activity.studentData, 'rt', {})
    activity.studentData.rt.hintCount = _.get(activity.studentData, 'rt.hintCount', 0)

    activityState.rt = {
      target: activity.score.scoreTarget,
      score: activity.score.activityScore,
      qr: activity.studentData.activity_questions_received,
      tp: [],
      hintCount: activity.studentData.rt.hintCount,
      completedQuestionCount: activity.score.completedQuestionCount,
      quizTimes: _.get(activity.studentData, 'rt.quizTimes', [])
    }

    const lastTimeObj = _.last(activityState.rt.quizTimes)
    const hasCompletedQuiz = activityState.rt.score >= activityState.rt.target

    // If we're starting the retake quiz for the first time,
    // push the first time object in quizTimes
    if (!activityState.rt.quizTimes.length) {
      activityState.rt.quizTimes.push({ startQuizTime: Date.now() })
      activity.studentData.rt.quizTimes = activityState.rt.quizTimes
    } else if (activity.score.activityScore === 0) {
      // if this is a subsequent retake, clear our quizTimes
      activityState.rt.quizTimes = [{ startQuizTime: Date.now() }]
      activity.studentData.rt.quizTimes = activityState.rt.quizTimes
    } else if (hasCompletedQuiz && !lastTimeObj.completeQuizTime) {
      // if we are finishing the quiz, then add completeQuizTime
      lastTimeObj.completeQuizTime = Date.now()
      activityState.rt.quizTimes.splice(-1, 1, lastTimeObj)
      activity.studentData.rt.quizTimes = activityState.rt.quizTimes
    } else if (!hasCompletedQuiz && lastTimeObj.startQuizTime && lastTimeObj.completeQuizTime) {
      // if we are returning to a quiz, push a new object onto it
      activityState.rt.quizTimes.push({ startQuizTime: Date.now() })
      activity.studentData.rt.quizTimes = activityState.rt.quizTimes
    }
  }

  
  if (activity.studentData.startQuizTime) {
    activityState.startQuizTime = activity.studentData.startQuizTime
  }
  if (activity.studentData.completeQuizTime) {
    activityState.completeQuizTime = activity.studentData.completeQuizTime
  }

  // build ARGA compatible activity state
  for (let i = 0; i < activity.allTopics.length; i++) {
    if (!isRetake) {
      const t = activity.allTopics[i]

      activityState.tp.push({
        qr: t.questionsReceived,
        nl: t.nextLevel,
        pa: t.totalPointsAvailable,
        pe: t.totalPointsEarned
      })
    } else {
      const t = activity.allTopics[i]
      const ft = activity.finalScore.allTopics[i]

      activityState.rt.tp.push({
        qr: t.questionsReceived,
        nl: t.nextLevel,
        pa: t.totalPointsAvailable,
        pe: t.totalPointsEarned
      })

      activityState.tp.push({
        qr: ft.questionsReceived,
        nl: ft.nextLevel,
        pa: ft.totalPointsAvailable,
        pe: ft.totalPointsEarned
      })
    }
  }

  payload.activity_state = activityState

  // also send requirements to verify token
  payload.token = getCookie('id_token')
  payload.resourceId = activity.config.itemId
  payload.lmsId = activity.config.lmsId || 'no-lms-id'

  const { core: { config: { LC_GRADE_SERVICE_URL, FF_USE_LC_GRADE_SERVICE }}} = getState();
  const apiEndpoint = FF_USE_LC_GRADE_SERVICE === 'true' ? `${LC_GRADE_SERVICE_URL}/` : getAPIendpointPrefix()

  saveProgressToDB({
    dispatch,
    activity,
    activityState,
    payload,
    apiEndpoint
  })
}

const saveProgressToDB = async ({
  dispatch = () => {},
  activity,
  activityState,
  payload,
  apiEndpoint
}) => {
  dispatch({ type: SAVE_PROGRESS_REQUEST })
  
  // fix for the launchpad iframe weirdness
  try {
    const response = await axiosWithRetry({
      url: apiEndpoint + 'api/v1/student_progress',
      method: 'POST',
      mode: 'no-cors',
      data: payload,
    })
    const { data, headers } = response
    if (
      !headers['content-type'].includes('application/json') ||
      data.error
    ) {
      throw new Error('unknown error')
    }
    if (data.badToken === true) {
      throw new Error('bad token')
    }

    // LST-958: Send after progress and completion timestamp has been updated
    if (activity.studentData.user_id_type === 'macmillan') {
      await gradeReportingHooks(
        dispatch,
        activityState.score,
        activityState.target,
        activity.config.itemId,
        activity.studentData.user_id,
        null,
        apiEndpoint
      )
    }

    dispatch({ type: SAVE_PROGRESS_SUCCESS, payload: data })
  } catch (error) {
    console.error(error)
    dispatch({ type: SHOW_NETWORK_ISSUE_MODAL })
    dispatch({ type: SAVE_PROGRESS_FAILURE, payload: { error } })
  }
}

async function gradeReportingHooks (dispatch, score, target, resourceId, userId, lmsId, apiEndpoint) {
  const curUrl = new Parse(window.location.href, null, true)
  const gradeTest = curUrl.query.gradeTest !== undefined ? 1 : 0

  let grade = score >= target ? 1 : 0

  if (!gradeTest && (!grade || !resourceId || !userId)) {
    return false
  } else if (gradeTest && (resourceId && userId)) {
    grade = 0
    console.log('Test grade of zero (0) being sent')
  } else if (grade === 0) {
    return false
  }

  const payload = {
    lmsId: lmsId || 'asd',
    userId,
    grade,
    resourceId,
    token: getCookie('id_token')
  }
  console.log(payload)

  // note: allow parent to catch error
  const response = await axiosWithRetry({
    url: apiEndpoint + 'api/v1/ptp/recordGrade',
    method: 'POST',
    credentials: 'include',
    data: payload
  })
  return response
}

export const mapQuestionViewData = (questions) => {
  return questions.map(q => ({
    timesTested: q.timesTested || 0,
    timesCorrect: q.timesCorrect || 0,
    meta: {
      fq_uid: q.meta?.fq_uid,
      primary_question: q.meta?.primary_question
    }
  }))
}

export default saveProgress
